import { defineMessages } from 'react-intl-next';

export const messages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-error-flag.title',
		defaultMessage: "We couldn't add you to {product}",
		description: 'Title shown in the invite error flag notification.',
	},
	description: {
		id: 'cross-join-nudges.request-access-error-flag.description-support-link',
		defaultMessage:
			"Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
		description: 'Description informing the user that request to join was not successfully sent',
	},
});
